import React, { Component } from 'react';
import comet_right from '../assets/comet_right.svg';
import comet_left from '../assets/comet_left.svg';
import TagsInput from 'react-tagsinput';
import picture from '../assets/Add_picture.svg';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import './IdeaModal.css'

class IdeaModal extends Component {
  constructor(props) {
    super(props);
    this.state = { iTags: [], iDescription: "", imageList: null, urlList: null, wrongTag: false, creationIdeaLoading: this.props.loading };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading !== this.state.creationIdeaLoading) {
      this.setState({ creationIdeaLoading: nextProps.loading })
    }
  }

  onChangeDescription = event => {
    this.setState({
      iDescription: event.target.value
    })
  };

  onChangeTags = array => {
    this.setState({
      iTags: array,
      wrongTag: false
    })
  };

  validateIdea = () => {
    const timestamp = Date.now();
    this.props.onAddIdea({ creator: this.props.creator, tags_idea: this.state.iTags, description_idea: this.state.iDescription, time: timestamp, attachments: this.state.imageList, urlList: this.state.urlList, nbLikes: 0, likeList: [] });
  }

  handleChangePicture = (event) => {
    const { imageList, urlList } = this.state
    event.persist();
    if (event.target.files[0]) {
      const current_image = event.target.files[0];
      let currentImagesList = imageList || [];
      let currentUrlList = urlList || [];
      currentImagesList.push(current_image);
      currentUrlList.push(URL.createObjectURL(current_image));
      this.setState({ urlList: currentUrlList, imageList: currentImagesList });
    }
  }

  rejectTag = () => {
    this.setState({ wrongTag: true })
  }

  render() {
    const {
      iDescription,
      iTags,
      urlList,
      creationIdeaLoading
    } = this.state;
    const { classes } = this.props

    let canSendIdea = false;

    if (iDescription === "") {
      canSendIdea = false
    } else {
      canSendIdea = true
    }

    let listUrl = urlList || []
    return (
      <div className="container">
        <img alt="comet" src={comet_left} />
        <h1 className="text-center title-idea mt-3">Proposer une Idée</h1>
        <div className="text-right">
          <img alt="comet" className="comet-pos" src={comet_right} />
        </div>
        <div className="row">
          <div className="col">
            <div className="mt-3">
              <h1 className="mb-3 text-idea">Ajouter un thème</h1>
              <TagsInput onValidationReject={this.rejectTag} validationRegex={/^[a-zA-Z0-9]{0,25}$/} maxTags={6} value={iTags} onChange={this.onChangeTags} />
            </div>
            <div hidden={!this.state.wrongTag}><h4 className="wrong-tag mt-2">Tag non valide</h4></div>
            <div className="mt-4 pb-3">
              <h1 className="mb-3 text-idea">Quelle est votre Idée ?</h1>
              <div>
                <input onChange={this.handleChangePicture} hidden={true} id="import-picture-modal" className="import" type="file" multiple />
                <textarea class="text-area-idea pl-3"
                  rows="4"
                  onChange={this.onChangeDescription}
                  placeholder="Description de l'idée"
                  name="test2"
                  value={iDescription}
                ></textarea>
                <div className="d-flex">
                  <label htmlFor="import-picture-modal" className="import">
                    <img alt="icon" className="cursor-pointer mr-2 mb-3 mt-1" src={picture} />
                  </label>
                  <div className="d-flex">
                    {listUrl.map((url) => <img className="picture-idea mr-2" src={url} alt="ideaPicture" />)}
                  </div>
                </div>
              </div>
            </div>
            {canSendIdea === true ? <div className="text-right mt-3 mb-2">
              <button className="btn-ok" onClick={this.validateIdea}>OK</button>
            </div> : <div className="text-right mt-3 mb-2">
                <button className="btn-ok-grey">OK</button>
              </div>}
          </div>
        </div>
        {creationIdeaLoading && <CircularProgress size={66} className={classes.buttonProgress} />}
      </div>
    )
  }
}

const styles_loader = theme => ({
  root: {
  },
  buttonProgress: {
    color: '#0070A2',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -33,
    marginLeft: -33,
  },
});

IdeaModal.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles_loader)(IdeaModal);